import React from 'react'

export default function HeaderBreak() {
    return (
        <div className='h-[72px]'></div>
    )
}
